<template>
  <ModalDefault
    modal_id="addTicketFromChat"
    :header="false"
    size="modal-xl modal-dialog-scrollable"
    style_header=""
    :modal_header="`Criar Ticket`"
    :footer="true"
    icon="bx bx-copy-alt mr-1"
  >
    <div slot="body">
    <div class="row border-bottom" style="position: sticky;background-color: white;    z-index: 999;">
      <div class="col-6"><h2>Criar Ticket</h2></div>
      <div class="col-6">
        <button v-if="canSave" class="btn new-button float-right">Salvar</button>
        <button v-else class="btn disabled float-right" disabled>Salvar</button>
      </div>
    </div>
    <div
      class="px-2 py-2 pb-3"
      style="height: 450px; overflow-y: auto; overflow-x: hidden;"
    >
      <fieldset class="my-4">
        <legend>Dados Pessoais</legend>
        <div class="row">
          <div class="col-6">
            <label class="labelStyle"
              >Nome do cliente:
              <a href="#" @click="openSearchLeads()"
                >Pesquisar <i class="bx bx-search-alt-2"></i></a
            ></label>
            <div v-if="searching_leads" id="autocomplete">
              <input
                v-model="search_lead_book"
                class="input-field"
                type="text"
                style="width: 100%; font-size: 14px !important"
                id="searchInput"
                minlength="3"
                placeholder="Digite o nome para pesquisar e pressione enter"
                @keydown.enter="searchLeadsBook()"
              />
              <div
                class="dropdown-menu dropdown-menu_navbar animated--fade-in item_hover animated--fade-in shadow"
                aria-labelledby="filterDropdown"
                onclick="event.stopPropagation();"
                style="
                  width: 31.5em;
                  margin-left: 1em;
                  background: white;
                  margin-top: -1em;
                "
              >
                <div
                  v-for="lead in chat.leads_book_pagination.data"
                  :key="lead.id"
                >
                  <div
                    class="select-lead pl-3 pt-2 pb-2 border-bottom"
                    @click="selectLead(lead)"
                  >
                    <span class="lead-name">{{ lead.name }}</span>
                    <small class="lead-phone">{{ lead.phone }}</small>
                  </div>
                </div>
              </div>
            </div>
            <Input
              v-else
              placeholder="Nome do cliente"
              id="leadName"
              style="width: 100%; font-size: 14px !important"
              @change="
                (e) => (kanban_cards.current_card.contact_infos.name = e)
              "
            />
          </div>
          <div class="col-6">
            <label class="labelStyle">Telefone:</label>
            <div class="row">
              <div class="col-2">
                <vue-country-dropdown
                  @onSelect="onSelect"
                  ref="vcd"
                  :preferredCountries="['BR', 'US', 'ES']"
                  :onlyCountries="channels.onlyCountries"
                  :enabledFlags="true"
                  :enabledCountryCode="true"
                  :immediateCallSelectEvent="true"
                  :showNameInput="false"
                  :showNotSelectedOption="false"
                  :notSelectedOptionText="'Selecione'"
                >
                </vue-country-dropdown>
              </div>
              <div class="col-10">
                <input
                  type="text"
                  id="phoneNumber2"
                  @keyup="
                    (e) => {
                      formatPhone(e);
                    }
                  "
                  class="input-field"
                  maxlength="12"
                />
              </div>
            </div>
            <span v-if="errors.contact_phone" class="text-danger pl-1">{{
              errors.contact_phone
            }}</span>
          </div>
          <div class="col-6">
            <label class="labelStyle">
              E-Mail:
            </label>
            <input
              type="text"
              id="leadEmail"
              class="input-field"
              maxlength="12"
            />
          </div>
          <div class="col-6">
            <label class="labelStyle">
              Empresa:
            </label>
            <input
              type="text"
              id="company"
              class="input-field"
              maxlength="12"
            />
          </div>
        </div>
      </fieldset>
      <fieldset>
        <legend>Dados do Ticket</legend>
        <div class="row">
          <div class="col-6">
            <label class="labelStyle">
              *Título:
            </label>
            <input type="text" class="input-field" jd="title" />
          </div>
          <div class="col-6">
            <label class="labelStyle">
              *Categoria:
            </label>
            <select name="category" class="input-field">
              <option>Category 1</option>
              <option>Category 2</option>
              <option>Category 3</option>
            </select>
          </div>
          <div class="col-6">
            <label class="labelStyle">
              *Prioridade:
            </label>
            <select name="priority" class="input-field">
              <option>Category 1</option>
              <option>Category 2</option>
              <option>Category 3</option>
            </select>
          </div>
          <div class="col-6">
            <label class="labelStyle">
              Previsão:
            </label>
            <input type="date" class="input-field" id="title" />
          </div>
          <div class="col-6">
            <div class="row">
              <div class="col-12">
                <label class="labelStyle">
                  Equipe:
                </label>
                <select name="department" class="input-field">
                  <option>Equipe 1</option>
                  <option>Equipe 2</option>
                  <option>Equipe 3</option>
                </select>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <label class="labelStyle">
                  Responsável:
                </label>
                <select name="user_id" class="input-field">
                  <option>User 1</option>
                  <option>User 2</option>
                  <option>User 3</option>
                </select>
              </div>
            </div>
          </div>
          <div class="col-6">
            <input
              type="file"
              @change.prevent="loadFile()"
              :id="`fileHandler`"
              hidden
            />
            <input type="hidden" v-model="gallery.current_media.file.url" />
            <div class="d-flex">
              <div class="d-block">
                <img
                  @click.stop="changeFileBot()"
                  v-b-tooltip.right
                  v-if="gallery.current_media.file.url === null"
                  :src="
                    gallery.current_media.file.url
                      ? gallery.current_media.file.url
                      : no_pic
                  "
                  :title="getTranslations('expression_294')"
                  style="
                    max-height: 140px;
                    min-height: 140px;
                    min-width: 140px;
                    max-width: 140px;
                    margin-left: 75px;
                    margin-top: 25px;
                  "
                  class="cursor_pointer shadow-sm"
                />
                <img
                  v-if="
                    ['image/png', 'image/jpeg', 'image/jpg'].includes(
                      gallery.current_media.file.mime_type
                    )
                  "
                  @click.stop="changeFileBot()"
                  :src="gallery.current_media.file.url"
                  style="
                    max-height: 200px;
                    min-height: 200px;
                    min-width: 200px;
                    max-width: 200px;
                    margin-left: 75px;
                  "
                  class="cursor-pointer shadow-sm"
                />
                <div
                  style="
                    max-height: 200px;
                    min-height: 200px;
                    min-width: 200px;
                    max-width: 200px;
                    margin-left: 75px;
                    display: flex;
                    align-items: center;
                    background-color: #f8fafb;
                    justify-content: center;
                  "
                  class="cursor-pointer shadow-sm"
                  @click.stop="changeFileBot()"
                  v-if="
                    ['application/pdf'].includes(
                      gallery.current_media.file.mime_type
                    )
                  "
                >
                  <i class="bx bxs-file-pdf" style="font-size: 55px"></i>
                </div>
                <div
                  style="
                    max-height: 200px;
                    min-height: 200px;
                    min-width: 200px;
                    max-width: 200px;
                    margin-left: 75px;
                    display: flex;
                    align-items: center;
                    background-color: #f8fafb;
                    justify-content: center;
                  "
                  class="cursor-pointer shadow-sm"
                  @click.stop="changeFileBot()"
                  v-if="
                    ['video/mpeg', 'video/mp4'].includes(
                      gallery.current_media.file.mime_type
                    )
                  "
                >
                  <i class="bx bx-camera-movie" style="font-size: 55px"></i>
                </div>
              </div>
              <div
                v-if="
                  gallery.current_media.file &&
                  gallery.current_media.file.url !== null
                "
              >
                <div class="pt-2" style="">
                  <i
                    v-b-tooltip.bottom
                    :title="getTranslations('expression_297')"
                    @click.stop="removeFileBot()"
                    class="bg-white text-secondary shadow-sm rounded-circle py-1 px-1 bx bx-x bx-xs cursor_pointer"
                  ></i>
                </div>
              </div>
            </div>
          </div>
          <div class="col-12">
            <vue-editor
              id="editor"
              :editor-toolbar="customToolbar"
              useCustomImageHandler
              @image-added="handleImageAdded"
              @image-removed="handleImageRemoved"
              :editorOptions="editorSettings"
              v-model="htmlForEditor"
            />
            <div id="counter" class="float-right">0</div>
          </div>
        </div>
      </fieldset>
    </div>
     </div>
    <div slot="footer" class="px-2 py-2"></div>
  </ModalDefault>
</template>
  
  <script>
import no_pic from "../../assets/img/no-pic.png";
import Modal from "../kanban/Modal.vue";
import ModalDefault from "../general/ModalDefault";
import Calendar from "../kanban/Calendar.vue";
import Input from "../kanban/Input.vue";
import { mapGetters, mapState } from "vuex";
import * as moment from "moment";
import $ from "jquery";
import { VueEditor, Quill } from "vue2-editor";
import { ImageDrop } from "quill-image-drop-module";
import ImageResize from "quill-image-resize-module";
import VueCountryDropdown from "vue-country-dropdown";
import Mention from "quill-mention-vue2-editor";

const FILE_MAX_SIZE = 11;
Quill.register("modules/imageDrop", ImageDrop);
Quill.register("modules/imageResize", ImageResize);
Quill.register("modules/mention", Mention);

function Counter(quill, options) {
  const container = document.querySelector(options.container);
  quill.on(Quill.events.TEXT_CHANGE, () => {
    const text = quill.getText();
    if (options.unit === 'word') {
      container.innerText = text.split(/\s+/).length + ' words';
    } else {
      container.innerText = text.length + ' characters';
    }

  });
}

Quill.register('modules/counter', Counter);



export default {
  name: "ModalAddTicket",
  components: {
    ModalDefault,
    Calendar,
    Input,
    VueEditor,
    VueCountryDropdown
  },
  props: ["visible"],
  emits: ["close"],
  computed: {
    ...mapState([
      "channels",
      "departments",
      "categories",
      "lead_requests",
      "configs",
      "me",
    ]),
    ...mapGetters([
      "getDepartmentsArray",
      "getCategoriesArray",
      "getCategoryObject",
      "getTranslation",
    ]),
  },
  data() {
    return {
      no_pic:no_pic,
      canSave: false,
      htmlForEditor: "",
      searching_leads: false,
      search_lead_book: "",
      customToolbar: [
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["image", "code-block"]
      ],
      editorSettings: {
        modules: {
          imageDrop: true,
          imageResize: {},
          counter: {
            container: '#counter',
            unit: 'character'
          },
          mention:{
            allowedChars: /^[A-Za-z\sÅÄÖåäö]*$/,
            mentionDenotationChars: ["@", "#"],
            source: (searchTerm, renderList, mentionChar) => {
              let values;
              let users = this.users.data.map((v, i) => {
                return {
                  id: v.id,
                  value: v.name
                }
              });
              
              const atValues = users;
              const hashValues = [
                { id: 3, value: 'Fredrik Sundqvist 2' },
                { id: 4, value: 'Patrik Sjölin 2' }
              ]

              if (mentionChar === "@") {
                values = atValues;
              } else {
                values = hashValues;
              }

              if (searchTerm.length === 0) {
                renderList(values, searchTerm);
              } else {
                const matches = [];
                for (let i = 0; i < values.length; i++)
                  if (
                    ~values[i].value.toLowerCase().indexOf(searchTerm.toLowerCase())
                  )
                    matches.push(values[i]);
                renderList(matches, searchTerm);
              }
            }
          }
        },
      },
      datetime_local_min: "",
      datetime_local_max: "",
      add_ticket: {
        title: null,
        due_date: null,
        text: null,
        user_id: null,
        priority_key: null,
      },
      error_exists: false,
      errors: {
        category_id: null,
        subcategory_id: null,
        expireted_at: null,
        description: null,
      },
    };
  },
  mounted() {
    // setTimeout(() => {
    //   //this.add_ticket.user_id = this.me.data.id
    // }, 500);
    // this.getCategoryNames();

    // $("#expiretedAtDate").attr(
    //   "min",
    //   new Date()
    //     .toISOString()
    //     .slice(0, new Date().toISOString().lastIndexOf(":"))
    // );
    const users = this.users.data;
  },
  methods: {
    loadFile() {
      const files = document.getElementById(`fileHandler`);
      if (files.files && files.files[0]) {
        this.creating_media = true;
        const file = files.files[0];
        if (
          [
            "image/png",
            "image/jpeg",
            "image/jpg",
            "application/pdf",
            "video/mpeg",
            "video/mp4",
          ].includes(file.type)
        ) {
          const size = file.size / 1024 / 1024;
          if (size <= FILE_MAX_SIZE) {
            const FR = new FileReader();
            const FD = new FormData();
            FD.append("file", files.files[0]);
            // FR.addEventListener("load", (e) => {
            //   //this.gallery.current_media.upload_file = e.target.result;

            //   // this.gallery.current_media.file = {
            //   //   url: e.target.result,
            //   //   mime_type: file.type
            //   // };
            // });
            FR.readAsDataURL(file);
            setTimeout(() => {
              api
                .post("https://upload.beecrm.io/upload", FD, {
                  headers: {
                    Authorization:
                      "Bearer SiWa70obgEFwuedQqxCLveQ2zqDXZXl4MSVGZ1sMHxuPjLVOsMB6sOxyoQcq8cql",
                  },
                })
                .then((response) => {
                  this.gallery.current_media.file.url = response.data.url;
                  this.gallery.current_media.file.mime_type = file.type;
                  this.gallery.current_media.file.size = file.size;
                  this.creating_media = false;
                });
            }, 100);
          } else {
            Swal.fire(
              `${this.getTranslations("expression_683")}`,
              `${this.getTranslations(
                "expression_681"
              )} <br/> <small>${this.getTranslations("expression_682")} ${
                file.name
              }</small>`,
              "warning"
            );
          }
        } else {
          Swal.fire(
            `${this.getTranslations("expression_683")}`,
            `${this.getTranslations(
              "expression_684"
            )} <br/> <small>${this.getTranslations(
              "expression_873"
            )}</small> <br/> <small>${this.getTranslations("expression_682")} ${
              file.name
            }</small>`,
            "warning"
          );
        }
      }
      //this.verifyStringBotForm();
      files.value = "";
    },

    changeFileBot() {
      $(`#fileHandler`).click();
    },
    removeFileBot(index) {
      api
        .delete("https://upload.beecrm.io/delete", {
          headers: {
            Authorization:
              "Bearer SiWa70obgEFwuedQqxCLveQ2zqDXZXl4MSVGZ1sMHxuPjLVOsMB6sOxyoQcq8cql",
          },
          data: {
            fileName: this.gallery.current_media.file.url.split("/").pop(),
          },
        })
        .then((response) => {
          this.gallery.current_media.file.url = null;
          this.gallery.current_media.file.mime_type = null;
        })
        .catch((e) => {
          this.gallery.current_media.file.url = null;
          this.gallery.current_media.file.mime_type = null;
        });
      //   setTimeout(() => {
      //     this.saveBot()
      //   }, 100)
    },
    selectLead(lead) {
      this.contact_lead_from_lead_books = true;

      let phone_ddi = lead.phone.substring(0, 2);
      let phone = lead.phone.substring(2);
      let name = lead.name;
      let email = lead.email;

      this.phone_lead = phone_ddi + phone;
      // this.kanban_cards.current_card.contact_infos.phone = phone_ddi + phone;
      this.kanban_cards.current_card.contact_infos.name = name;

      this.manualTriggerCountryDropdown(phone_ddi);

      this.searching_leads = false;

      // using jquery
      setTimeout(() => {
        $("#autocomplete .dropdown-menu").hide();
        $("#leadName").val(name);
        $("#phoneNumber2").val(phone);
        $("#leadEmail").val(email);
        $("#searchInput").val("");
      }, 1);
    },
    openSearchLeads() {
      this.searching_leads = true;
      setTimeout(() => {
        $("#searchInput").val("");
        $("#leadName").val("");
        $("#phoneNumber2").val("");
      }, 1);
    },
    searchLeadsBook() {
      if (this.search_lead_book.length > 0) {
        let search = this.xeroxHelper(this.search_lead_book);
        if (!isNaN(parseFloat(search)) && isFinite(search)) {
          this.$store.dispatch("getLeadsBook", { phone: search });
        } else {
          this.$store.dispatch("getLeadsBook", { name: search });
        }
        setTimeout(() => {
          $("#autocomplete .dropdown-menu").show();
        }, 1000);
      } else {
        this.$store.dispatch("getLeadsBook", {});
      }
    },

    manualTriggerCountryDropdown(areaCode) {
      const defaultCountry = this.$refs.vcd.findCountryByAreaCode(areaCode);
      this.$refs.vcd.choose(defaultCountry);

      // .manualDropdown();
    },
    onSelect({ name, iso2, dialCode }) {
      this.kanban_cards.current_card.contact_infos.phone_ddi = dialCode;
    },
    handleImageRemoved: function(file){
      api
        .delete("https://upload.beecrm.io/delete", {
          headers: {
            Authorization:
              "Bearer SiWa70obgEFwuedQqxCLveQ2zqDXZXl4MSVGZ1sMHxuPjLVOsMB6sOxyoQcq8cql",
          },
          data: {
            fileName: file.split("/").pop(),
          },
        })
        .then((response) => {
        })
        .catch((e) => {
        });
    },
    handleImageAdded: function(file, Editor, cursorLocation, resetUploader) {
        // An example of using FormData
        // NOTE: Your key could be different such as:
        // formData.append('file', file)
        var formData = new FormData();
        formData.append("file", file);

        api.post('https://upload.beecrm.io/upload', formData, {
          headers:{
            "Authorization":"Bearer SiWa70obgEFwuedQqxCLveQ2zqDXZXl4MSVGZ1sMHxuPjLVOsMB6sOxyoQcq8cql"
          }
        }).then(response => {
          const url = response.data.url; // Get url from response
          Editor.insertEmbed(cursorLocation, "image", url);
          resetUploader();
        })
        .catch(err => {
        });
    },
    async getCategoryNames() {
      await api
        .get(`/lead-request/category-names`, {
          params: {
            department_id: this.chat.ticket.department_id,
          },
        })
        .then((response) => {
          //context.commit("SET_COLUMNS_VALUE", response.data);
          this.categories.data = response.data;
        });
    },
    setCategory(e) {
      this.lead_requests.new_lead_request.category_id = e.target.value;
      this.categories.subcategories = [];
      let subCategories = this.categories.data.find((category, index) => {
        return category.id == e.target.value;
      }).subcategories;
      this.categories.subcategories = subCategories;
    },
    setSubCategory(e) {
      this.lead_requests.new_lead_request.subcategory_id = e.target.value;
    },
    closeModal() {
      this.$emit("close");
    },

    validateFields() {
      this.error_exists = false;

      this.errors.category_id = null;
      this.errors.subcategory_id = null;
      this.errors.expireted_at = null;
      this.errors.description = null;

      if (
        ["", null].includes(this.lead_requests.new_lead_request.category_id)
      ) {
        this.error_exists = true;
        this.errors.category_id = "Campo Obrigatório";
      }

      if (
        ["", null].includes(this.lead_requests.new_lead_request.subcategory_id)
      ) {
        this.error_exists = true;
        this.errors.subcategory_id = "Campo Obrigatório";
      }

      if (
        ["", null].includes(this.lead_requests.new_lead_request.expireted_at)
      ) {
        this.error_exists = true;
        this.errors.expireted_at = "Campo Obrigatório";
      }

      if (
        ["", null].includes(this.lead_requests.new_lead_request.description)
      ) {
        this.error_exists = true;
        this.errors.description = "Campo Obrigatório";
      }

      if (!this.error_exists) {
        this.saveTicket();
      }
    },
    saveTicket() {
      this.lead_requests.new_lead_request.ticket_id = this.chat.ticket.id;
      this.lead_requests.new_lead_request.lead_id = this.chat.ticket.lead_id;
      this.$store.dispatch(
        "addLeadRequest",
        this.lead_requests.new_lead_request
      );
      this.closeModal();
    },
    datetime_local() {
      this.datetime_local_max = moment().add(15, "days").format().slice(0, -9);
      this.datetime_local_min = moment().add(1, "hours").format().slice(0, -9);
    },
  },
};
</script>


<style scoped>
.new-button {
  border-radius: 5px !important;
  background-color: #192730 !important;
  color: white !important;
  font-size: larger !important;
}
.caret.blue {
  border-top: 4px solid #0693e3;
}
.form-control:disabled,
.form-control[readonly] {
  background-color: #fff;
}
.custom-select:disabled {
  color: #28282d;
  background-color: #fff;
}
.input-field {
  width: 100%;
  height: 2.5rem;
  border: 1px solid rgb(156 163 175 / 0.55);

  outline: none;
  background-color: white;
  color: #858796;
  @apply px-2;
}

.input-field:focus {
  border: 1px solid #919191;
}
.textarea {
  width: 100%;
  border: 1px solid rgb(156 163 175 / 0.55);

  outline: none;
  background-color: white;
  color: #858796;
  height: 8rem;
  resize: none;
  @apply p-2;
}
.textarea:focus {
  border: 1px solid #919191;
}
</style>